<template>
  <GridContainer form-container>
    <el-form
      label-position="left"
      @submit.native.prevent
    >
      <el-form-item v-if="loginError.show">
        <el-alert
          type="error"
          :title="loginError.message"
          @close="loginError.show = false"
        />
      </el-form-item>

      <el-form-item v-if="$v.user.email.required && $v.user.email.$error">
        <el-alert
          type="error"
          title="This is not a valid email"
        />
      </el-form-item>

      <el-form-item v-if="$v.user.password.$error">
        <el-alert
          type="error"
          title="Password must be 8 characters"
        />
      </el-form-item>

      <el-form-item label="Email">
        <el-input
          v-model="user.email"
          autofocus
          type="text"
          placeholder="Type your email"
          name="email"
          clearable
          @blur="$v.user.email.$touch()"
          @keyup.enter.native="loginOnEnter"
        />
      </el-form-item>

      <el-form-item>
        <template slot="label">
          <el-row>
            <el-col :span="12">
              Password
            </el-col>
            <el-col :span="12">
              <div
                class="el-button el-button--text label-button"
                @click="changePasswordDisplay"
              >
                {{ showPasswordState }} Password
                <i
                  class="fa"
                  :class="showPasswordClass"
                  aria-hidden="true"
                />
              </div>
            </el-col>
          </el-row>
        </template>

        <el-input
          v-model="user.password"
          :type="passwordType"
          placeholder="Enter password"
          name="password"
          clearable
          @blur="$v.user.password.$touch()"
          @keyup.enter.native="loginOnEnter"
        />
        <a
          class="forgot-text"
          @click="showResetForm"
        >Forgot Password?</a>
      </el-form-item>

      <el-form-item>
        <el-button
          class="width-100"
          :disabled="$v.user.$invalid"
          type="primary"
          @click="login"
        >
          Login
        </el-button>
      </el-form-item>
    </el-form>

    <el-dialog
      append-to-body
      title="Reset Password"
      top="25vh"
      :visible.sync="resetForm.show"
    >
      <el-form
        label-position="left"
        @submit.native.prevent
      >
        <el-form-item label="Email">
          <el-input
            v-model="resetForm.email"
            type="text"
            placeholder="Type your email"
            clearable
            @blur="$v.resetForm.email.$touch()"
            @keyup.enter.native="resetPasswordOnEnter"
          />
        </el-form-item>
      </el-form>

      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          class="margin-right-unit"
          type="text"
          @click="resetForm.show = false"
        >
          Cancel
        </el-button>

        <el-button
          type="primary"
          :disabled="$v.resetForm.$invalid"
          @click="resetPassword()"
        >
          Reset Password
        </el-button>
      </span>
    </el-dialog>
  </GridContainer>
</template>

<script>
import axios from '@/axios/axios'

import { validationMixin } from 'vuelidate'
import { required, email, minLength } from 'vuelidate/lib/validators'

export default {
  name: 'Login',
  mixins: [ validationMixin ],
  data() {
    return {
      resetForm: {
        show: false,
        email: ''
      },
      user: {
        email: '',
        password: ''
      },
      loginError: {
        show: false,
        message: ''
      },
      passwordType: 'password'
    }
  },
  computed: {
    route() {
      return this.$route
    },

    showPasswordState() {
      return (this.passwordType === 'password') ? 'Show' : 'Hide'
    },

    showPasswordClass() {
      return (this.passwordType === 'password') ? 'fa-eye' : 'fa-eye-slash'
    }
  },
  validations: {
    user: {
      email: {
        required,
        email: function(val) {
          if (!this.$isProduction) return true
          return email(val)
        }
      },
      password: {
        required,
        minLength: function(val) {
          if (!this.$isProduction) return true
          return minLength(8)(val)
        }
      }
    },
    resetForm: {
      email: {
        required,
        email
      }
    }
  },
  methods: {
    changePasswordDisplay() {
      this.passwordType = (this.passwordType === 'password') ? 'text' : 'password'
    },

    loginOnEnter() {
      if (!this.$v.user.$invalid) {
        this.login()
      }
    },

    resetPasswordOnEnter() {
      if (!this.$v.resetForm.$invalid) {
        this.resetPassword()
      }
    },

    resetPassword() {
      const data = {
        email: this.resetForm.email
      }

      return axios.post('account/reset_password/init', data)
        .then(res => {
          if (res.status === 200) {
            this.$notify({
              title: 'Success',
              message: 'We have sent you an email in order to reset your password.',
              type: 'success'
            })
          }

          this.resetForm.show = false
        })
        .catch(axios.errorNotify)
    },

    login() {
      const data = {
        username: this.user.email,
        password: this.user.password
      }

      this.$store.dispatch('login', {
        method: 'login',
        data,
        vm: this,
        route: this.route
      })
        .catch(err => {
          this.loginError.show = true
          this.loginError.message = err
        })
    },

    showResetForm() {
      this.resetForm.show = true

      // Pre-populate reset email with the login email, if exists
      if (!this.user.email.$invalid) {
        this.resetForm.email = this.user.email
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~vars";

  .label-button {
    font-size: $-font-size-s;
    padding: 8px;
    float: right;
  }
</style>
